<template>
  <div class="inv-trans-delivery-record">
    <!-- <div class="change-title ub ub-sp">
      <el-radio-group
        v-model="formSearch.orgType"
        @change="onPageChange({page: 1})"
        style="vertical-align: top;"
      >
        <el-radio-button label>全部</el-radio-button>
        <el-radio-button label="HQ">工厂</el-radio-button>
        <el-radio-button label="SC">售后公司</el-radio-button>
      </el-radio-group>
    </div> -->

    <div class="table-bd">
      <custom-table
        index
        :data="tableList"
        tableCode="contractDeliver"
        @sort-change="sortChange"
        @filter-change="filterChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
// 发货记录
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
    bizId: String
  },
  data() {
    return {
      contractStatus: 'all',
      formSearch: {
        bizId: '',
        orgType: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        outStartDate: undefined,
        outEndDate: undefined,
      },
      dataTimes: [],

      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId') || this.bizId;
    this.getTableList();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.transferOrderOutPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 日期范围
    onChangeDate: function () {
      this.formSearch.outStartDate = this.dataTimes && this.dataTimes[0] ? this.dataTimes[0] : undefined;
      this.formSearch.outEndDate = this.dataTimes && this.dataTimes[1] ? this.dataTimes[1] : undefined;
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang='scss'>
@import 'style/colors.scss';

.inv-trans-delivery-record {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
  .table-bd {
    margin-top: 24px;
  }
}
</style>
